import { render, staticRenderFns } from "./Decimal.vue?vue&type=template&id=3e33aaaf"
import script from "./Decimal.vue?vue&type=script&lang=ts"
export * from "./Decimal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports